<template>
  <div class="subtable">
    <Table :columns="columnsSub" :data="data"   :loading="loading"></Table>
  </div>
</template>
<script>
  import {followInTimeRateGroupByZo} from "../../../../api/reporter";
  import {deepClone} from "../../../../utils/format";

  export default {
    // name: "subtable",
    props:{
      columns:{
        type:Array,
        default:function(){return []}
      },
      params:{
        type:Object,
        default:null
      },
    },
    computed:{
      columnsSub(){
        if(this.columns.length===0){
          return []
        }

        let ret=deepClone(this.columns)
        ret[0].type=''
        ret[0].render=null
        ret[1].key='zoName'
        return ret
      }


    },
    data(){
      return {
        data:[],
        loading:true
      }
    },
    created(){
      followInTimeRateGroupByZo(this.params).then(res=>{
        if(!res.data){
          return
        }
        this.data=res.data
        // this.total=res.data.total
      }).catch(error=>{}).finally(()=>{
        this.loading=false

      })

    }
  }
</script>

<style scoped>

</style>
